import { combineReducers } from "redux";

// Import custom components
import authReducer from "./auth/authReducer";
import companyReducer from "./auth/companyReducer";
import clientDetailReducer from "./client/clientDetailReducer"
import navReducer from "./navigation/navReducer";
import scoreSummary from "./client/scoreSummary";
import loanSummary from "./client/loanSummary";
import UploadFileReducer from "./uploadFile/uploadFile.reducer";
import calculatorSettingReducer from "./salesSumary/calculatorSetting";
import currentPaymentReducer from "./salesSumary/currentPaymentReducer";
import clientTags from "./client/tagsReducer";
import clientHeaderDetailReducer from "./client/clientHeaderDetailReducer";

import { reducer as formReducer } from "redux-form";

const appReducer = combineReducers({
  auth: authReducer,
  company: companyReducer,
  clientDetail: clientDetailReducer,
  nav: navReducer,
  scoreSummary: scoreSummary,
  loanSummary: loanSummary,
  uploadFile: UploadFileReducer,
  currentPayment: currentPaymentReducer,
  calculatorSetting: calculatorSettingReducer,
  form: formReducer,// ← redux-form,
  clientTags: clientTags,
  clientHeaderDetail : clientHeaderDetailReducer
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state

  if (action.type === 'LOG_OUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
